import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	AdressverwaltungFacade,
	KontaktKategorie,
	KontaktInVerfahrenListResource,
	VerfahrenKontaktResource,
} from '@schir-int-client/adressverwaltung-shared';
import { VerfahrenResource } from '@schir-int-client/verfahren-shared';
import { Observable } from 'rxjs';

/**
 * Auflistung nach Kategorie wie in der alten Ansicht hat keiner vermisst, daher nicht mehr unterstützt.
 * Falls doch nötig, kann man später eine Filterfunktion einbauen (z.B. zeige alle Eigentümer).
 */
@Component({
	selector: 'schir-int-client-kontakt-list',
	templateUrl: './kontakt-list.component.html',
	styleUrls: ['./kontakt-list.component.scss'],
	standalone: false,
})
export class KontaktListComponent {
	@Input() verfahren: VerfahrenResource;

	@Output() unassignKontakt: EventEmitter<VerfahrenKontaktResource> = new EventEmitter();

	kategorie = KontaktKategorie;

	kontakteInVerfahren: Observable<KontaktInVerfahrenListResource>;

	constructor(private facade: AdressverwaltungFacade) {
		this.kontakteInVerfahren = this.facade.kontakteInVerfahren;
	}
}
